// @ts-nocheck
import { CartLineModel } from "@insite/client-framework/Types/ApiModels";

export const getQuantityFromProperties = (cartLines: CartLineModel[]) => {
    const newCartLines: CartLineModel[] = cartLines.map(cartLine => {
        const quantityString = cartLine.properties?.qtyAddedToCart ?? "";
        const parsedQuantity = quantityString !== undefined && quantityString !== "" ? Number(quantityString) : NaN;
        const qtyOrdered = Number.isFinite(parsedQuantity) ? parsedQuantity : cartLine.qtyOrdered;
        return {
            ...cartLine,
            qtyOrdered,
        };
    });

    return newCartLines;
};

const getAddToCartForTracking = (cartLines: CartLineModel[] | null) => {
    if (!cartLines?.length) {
        return { items: [] };
    }

    const addedCartLines = [...cartLines, ...(cartLines[0].additionalCartLineResultCollection ?? [])];

    return { items: getQuantityFromProperties(addedCartLines) };
};

export default getAddToCartForTracking;
